module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/header-image-mobile-03-c2577b9e52167c504cee302612c195e0.jpg";